// Znak aplikacji w belce i na ekranach logowania: sama nazwa klubu. Na ciemnym
// (czerwonym) tle — tekst biały.
import { CLUB_NAME } from '../lib/club'

export function HubWordmark({ className = '' }: { className?: string }) {
  return <span className={`font-extrabold tracking-[0.02em] ${className}`}>{CLUB_NAME}</span>
}
